import moment from 'moment';

import WeixinIcon from '@intelligence/assets/imgs/casualDailyReports/icon-weixin.png';
import DouyinIcon from '@intelligence/assets/imgs/casualDailyReports/icon-dy.png';
import { LANGUAGE_CN, LANGUAGE_EN } from '@intelligence/_config/config';

import { newPublisherCheckboxList, newPublisherCheckboxListMobileUpcoming, storeRankTopBasicInfoFormItem, storeRankTopRankingsFormItem } from './common';

import type { BusinessDownloadConfig } from '../types';

const defaultDate = moment().format('YYYY-MM-DD');

const mobileConfig: BusinessDownloadConfig = {
  'mobile-activeuser': {
    apiUrl: 'api/v1/intelligence_pc/topChartMobileCommonMetricExcel',
    bubbleText: 'dbi_info_download_tip',
    translate: true,
    formList: [
      {
        label: 'dbi_source',
        type: 'checkboxGroup',
        field: 'data_sources',
        defaultValue: ['appannie', 'sensortower'],
        options: [
          { label: 'data.ai', value: 'appannie' },
          { label: 'Sensor Tower', value: 'sensortower' },
        ],
      },
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['dau', 'revenue', 'arpu', 'download'],
        options: [
          { label: 'dbi_active_users', value: 'dau' },
          { label: 'Revenue', value: 'revenue' },
          { label: 'dbi_arpu', value: 'arpu' },
          { label: 'dbi_downloads', value: 'download' },
        ],
      },
      newPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'checkboxGroup',
            defaultValue: ['aggregated'],
            field: 'edition_method',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            message: 'dbi_label_time_settings_tips',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
            ],
          },
          {
            label: '',
            type: 'checkboxGroup',
            field: 'download_date_type',
            message:
              'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            defaultValue: ['daily'],
            options: [
              { label: 'dbi_daily', value: 'daily' },
              { label: 'dbi_weekly', value: 'weekly' },
              { label: 'dbi_monthly', value: 'monthly' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
              { label: 'dbi_label_separate_by_region_combine', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
          // {
          //   label: 'dbi_revenue_setting',
          //   type: 'revenueSettings',
          //   defaultValue: '',
          //   field: 'revenue_setting',
          // }
        ],
      },
    ],
  },
  'mobile-activeuser-studio': {
    apiUrl: 'api/v1/intelligence_pc/topChartMobileCommonMetricExcel',
    bubbleText: 'dbi_info_download_tip',
    translate: true,
    formList: [
      {
        label: 'dbi_source',
        type: 'checkboxGroup',
        field: 'data_sources',
        defaultValue: ['appannie', 'sensortower'],
        options: [
          { label: 'data.ai', value: 'appannie' },
          { label: 'Sensor Tower', value: 'sensortower' },
        ],
      },
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['dau', 'revenue', 'arpu', 'download'],
        options: [
          { label: 'dbi_active_users', value: 'dau' },
          { label: 'Revenue', value: 'revenue' },
          { label: 'dbi_arpu', value: 'arpu' },
          { label: 'dbi_downloads', value: 'download' },
        ],
      },
      newPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'checkboxGroup',
            defaultValue: ['aggregated'],
            field: 'edition_method',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            message:
              'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
            ],
          },
          {
            label: '',
            type: 'checkboxGroup',
            field: 'download_date_type',
            message:
              'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            defaultValue: ['daily'],
            options: [
              { label: 'dbi_daily', value: 'daily' },
              { label: 'dbi_weekly', value: 'weekly' },
              { label: 'dbi_monthly', value: 'monthly' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
              { label: 'dbi_label_separate_by_region_combine', value: 'region' },
            ],
          },

          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
          // {
          //   label: 'dbi_revenue_setting',
          //   type: 'revenueSettings',
          //   defaultValue: '',
          //   field: 'revenue_setting',
          // }
        ],
      },
    ],
  },
  'mobile-revenue': {
    apiUrl: 'api/v1/intelligence_pc/topChartMobileCommonMetricExcel',
    bubbleText: 'dbi_info_download_tip',
    translate: true,
    formList: [
      {
        label: 'dbi_source',
        type: 'checkboxGroup',
        field: 'data_sources',
        defaultValue: ['appannie', 'sensortower'],
        options: [
          { label: 'data.ai', value: 'appannie' },
          { label: 'Sensor Tower', value: 'sensortower' },
        ],
      },
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['revenue', 'arpu'],
        options: [
          { label: 'Revenue', value: 'revenue' },
          { label: 'dbi_arpu', value: 'arpu' },
        ],
      },
      newPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'checkboxGroup',
            defaultValue: ['aggregated'],
            field: 'edition_method',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            message:
              'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
            ],
          },
          {
            label: '',
            type: 'checkboxGroup',
            field: 'download_date_type',
            message:
              'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            defaultValue: ['daily'],
            options: [
              { label: 'dbi_daily', value: 'daily' },
              { label: 'dbi_weekly', value: 'weekly' },
              { label: 'dbi_monthly', value: 'monthly' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
              { label: 'dbi_label_separate_by_region_combine', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
          // {
          //   label: 'dbi_revenue_setting',
          //   type: 'revenueSettings',
          //   defaultValue: '',
          //   field: 'revenue_setting',
          // }
        ],
      },
    ],
  },

  'mobile-downloads': {
    apiUrl: 'api/v1/intelligence_pc/topChartMobileCommonMetricExcel',
    bubbleText: 'dbi_info_download_tip',
    translate: true,
    formList: [
      {
        label: 'dbi_source',
        type: 'checkboxGroup',
        field: 'data_sources',
        defaultValue: ['appannie', 'sensortower'],
        options: [
          { label: 'data.ai', value: 'appannie' },
          { label: 'Sensor Tower', value: 'sensortower' },
        ],
      },
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['download'],
        options: [{ label: 'dbi_downloads', value: 'download' }],
      },
      newPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'checkboxGroup',
            defaultValue: ['aggregated'],
            field: 'edition_method',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            message: 'dbi_label_time_settings_tips',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
            ],
          },
          {
            label: '',
            type: 'checkboxGroup',
            field: 'download_date_type',
            message:
              'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            defaultValue: ['daily'],
            options: [
              { label: 'dbi_daily', value: 'daily' },
              { label: 'dbi_weekly', value: 'weekly' },
              { label: 'dbi_monthly', value: 'monthly' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
              { label: 'dbi_label_separate_by_region_combine', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },

  'mobile-rpd': {
    apiUrl: 'api/v1/intelligence_pc/topChartMobileRpdExcel',
    bubbleText: 'dbi_info_download_tip',
    translate: true,
    formList: [
      {
        label: 'dbi_source',
        type: 'checkboxGroup',
        field: 'data_sources',
        defaultValue: ['sensortower'],
        options: [{ label: 'Sensor Tower', value: 'sensortower' }],
      },
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['rpd', 'revenue', 'download'],
        options: [
          { label: 'RPD($)', value: 'rpd' },
          { label: 'dbi_metric_cumulative_revenue_$', value: 'revenue' },
          { label: 'dbi_metric_cumulative_downloads', value: 'download' },
        ],
      },
      newPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'checkboxGroup',
            defaultValue: ['aggregated'],
            field: 'edition_method',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
            ],
          },
          // {
          //   label: '',
          //   type: 'checkboxGroup',
          //   field: 'download_date_type',
          //   message:
          //     'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
          //   defaultValue: ['monthly'],
          //   options: [
          //     { label: 'dbi_daily', value: 'daily' },
          //     { label: 'dbi_weekly', value: 'weekly' },
          //     { label: 'dbi_monthly', value: 'monthly' },
          //   ],
          // },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
              { label: 'dbi_label_separate_by_region_combine', value: 'region' },
            ],
          },
        ],
      },
    ],
  },

  'mobile-retention': {
    apiUrl: 'api/v1/intelligence_pc/topChartMobileRetentionExcel',
    bubbleText: 'dbi_info_download_tip',
    translate: true,
    formList: [
      {
        label: 'dbi_source',
        type: 'checkboxGroup',
        field: 'data_sources',
        defaultValue: ['sensortower'],
        options: [{ label: 'Sensor Tower', value: 'sensortower' }],
      },
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['D2', 'D3', 'D7', 'D15', 'D31'],
        options: [
          { label: 'D2', value: 'D2' },
          { label: 'D3', value: 'D3' },
          { label: 'D7', value: 'D7' },
          { label: 'D15', value: 'D15' },
          { label: 'D31', value: 'D31' },
        ],
      },
      newPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'checkboxGroup',
            defaultValue: ['aggregated'],
            field: 'edition_method',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
            ],
          },
          {
            label: '',
            type: 'checkboxGroup',
            field: 'download_date_type',
            message:
              'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            defaultValue: ['monthly'],
            options: [
              { label: 'dbi_daily', value: 'daily', disabled: true },
              { label: 'dbi_weekly', value: 'weekly', disabled: true },
              { label: 'dbi_monthly', value: 'monthly' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
              { label: 'dbi_label_separate_by_region_combine', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },
  'mobile-demographics': {
    apiUrl: 'api/v1/intelligence_pc/demographicsExcel',
    bubbleText: '',
    translate: true,
    getFormList: (tableParams: any) => {
      const source = tableParams?.source || 'sensortower';
      const isSensorTower = source === 'sensortower';

      // sensortower: lifetime/quarter 切换；appannie: 仅 month
      const timeSettingsItem = isSensorTower
        ? {
            label: 'dbi_label_time_settings',
            type: 'dateRangeDynamic' as const,
            defaultValue: [tableParams?.start_date || '', tableParams?.end_date || ''],
            field: 'dateRange',
            message: 'Multiple months can be selected at once. Data will be exported separately by month.',
            options: [],
            // 额外配置，传递给 RangePicker
            typeList: ['lifetime', 'quarter'],
            defaultType: tableParams?.granularity === 'quarterly' ? 'quarter' : 'lifetime',
            selectClassName: 'dbi_demographics-select',
            customComponentClassName: 'dbi_demographics-custompicker',
            rangePickerClassName: 'dbi_demographics-rangepicker',
            // overlayClassName: 'dbi_demographics-rangepicker-overlay',
            optionsMap: {
              lifetime: { value: 'lifetime', text: 'Lifetime', text_cn: '全周期', type: 'date' },
            },
            customOption: {
              lifetime: {
                disabled: true,
              },
              quarter: {
                showSelectType: false,
                useStartOfQuarter: true,
              },
            },
          }
        : {
            label: 'dbi_label_time_settings',
            type: 'dateRangeMonth' as const,
            defaultValue: ['2023-06-01', '2023-06-30'],
            field: 'dateRange',
            message: 'Multiple months can be selected at once. Data will be exported separately by month.',
            options: [],
          };

      return [
        {
          label: 'dbi_label_metrics',
          type: 'checkboxGroup',
          field: 'download_metrics',
          defaultValue: ['mau', 'demographics'],
          options: [
            { label: 'dbi_mau', value: 'mau' },
            { label: 'dbi_demographics', value: 'demographics' },
          ],
        },
        newPublisherCheckboxList,
        {
          label: 'dbi_label_data_calculation',
          type: 'subForm',
          children: [
            {
              label: 'dbi_label_palyform_Setting',
              type: 'checkboxGroup',
              field: 'platforms',
              defaultValue: ['appstore', 'googleplay'],
              options: [
                { label: 'IOS', value: 'appstore' },
                { label: 'Google Play', value: 'googleplay' },
              ],
            },
            timeSettingsItem,
            {
              label: 'dbi_label_country_settings',
              type: 'countrySingleSelect' as const,
              field: 'download_markets',
              defaultValue: tableParams?.markets || ['global'],
              message: 'Multiple countries can be selected at once. Data will be exported separately by country.',
              options: [],
            },
            {
              label: 'dbi_label_ratio',
              type: 'switch',
              defaultValue: true,
              field: 'ratio_show',
              options: [],
            },
          ],
        },
      ];
    },
  },
  'mobile-upcoming': {
    apiUrl: 'api/v1/intelligence_pc/mobileUpcomingExcel',
    bubbleText: '',
    translate: true,
    formList: [newPublisherCheckboxListMobileUpcoming],
  },

  'mobile-newRelease': {
    apiUrl: 'api/v1/intelligence_pc/mobileNewReleaseExcel',
    translate: true,
    formList: [newPublisherCheckboxList],
    bubbleText: '',
  },

  'mobile-databrain': {
    // apiUrl: 'api/v1/intelligence_pc/topChartMobileMetricExcel',
    apiUrl: 'api/v1/intelligence_pc/topChartMobileCommonMetricExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_source',
        type: 'checkboxGroup',
        field: 'data_sources',
        defaultValue: ['ogdb', 'appannie', 'sensortower'],
        options: [
          { label: 'DataBrain', value: 'ogdb' },
          { label: 'data.ai', value: 'appannie' },
          { label: 'Sensor Tower', value: 'sensortower' },
        ],
      },
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['dau', 'revenue', 'download'],
        options: [
          { label: 'dbi_active_users', value: 'dau' },
          { label: 'Revenue', value: 'revenue' },
          { label: 'dbi_downloads', value: 'download' },
        ],
      },
      newPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'checkboxGroup',
            defaultValue: ['aggregated'],
            field: 'edition_method',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            message:
              'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
            ],
          },
          {
            label: '',
            type: 'checkboxGroup',
            field: 'download_date_type',
            message:
              'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            defaultValue: ['daily'],
            options: [
              { label: 'dbi_daily', value: 'daily' },
              { label: 'dbi_weekly', value: 'weekly' },
              { label: 'dbi_monthly', value: 'monthly' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
              { label: 'dbi_label_separate_by_region_combine', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },
  'mobile-store-rank-more': {
    apiUrl: '/api/v1/intelligence_pc/topChartsMobileStoreRankExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_time_settings',
        type: 'dateRangeDay',
        defaultValue: [defaultDate, defaultDate],
        field: 'dateRange',
        // message:
        //   'Multiple months can be selected at once. Data will be exported separately by month.',
        options: [],
      },
    ],
  },
  'mobile-store-rank-top': {
    apiUrl: '/api/v1/intelligence_pc/topChartsMobileStoreRankExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_time_settings',
        type: 'dateRangeDay',
        defaultValue: [defaultDate, defaultDate],
        field: 'dateRange',
        options: [],
      },
      storeRankTopRankingsFormItem,
      storeRankTopBasicInfoFormItem,
    ],
  },
  'weixin-store-rank-more': {
    apiUrl: '/api/v1/intelligence_pc/topChartsMobileStoreRankExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'text',
        text: 'top',
      },
      {
        label: 'dbi_download_language',
        type: 'radio',
        field: 'download_language',
        defaultValue: LANGUAGE_CN,
        options: [
          { label: 'dbi_download_language_option_cn', value: LANGUAGE_CN },
          { label: 'dbi_download_language_option_en', value: LANGUAGE_EN },
        ],
      },
      {
        label: 'dbi_label_basic_info',
        type: 'checkbox',
        field: 'data_sources',
        defaultValue: {
          company_show: false,
          genre_show: false,
        },
        options: [
          { label: 'dbi_label_company_info', value: 'company_show' },
          { label: 'dbi_label_genre', value: 'genre_show' },
        ],
      },
      {
        label: 'dbi_label_time_settings',
        type: 'dateRangeDay',
        defaultValue: [defaultDate, defaultDate],
        field: 'dateRange',
        // message:
        //   'Multiple months can be selected at once. Data will be exported separately by month.',
        options: [],
      },
      {
        label: 'dbi_label_data_calculation_change',
        type: 'switch',
        defaultValue: true,
        field: 'ratio_show',
        options: [],
      },
    ],
  },
  'minigame-details-store-rank': {
    apiUrl: '/api/v1/intelligence_pc/game/genre_profile/metrics',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'minigameMetricSelector',
        field: 'minigame_types',
        defaultValue: [
          'wechat_popularity',
          'wechat_bestseller',
          'wechat_most_played',
          'douyin_popularity',
          'douyin_bestseller',
          'douyin_fresh_game',
        ],
        options: [
          { label: 'dbi_top_rank_wechat_popularity', value: 'wechat_popularity', icon: WeixinIcon },
          { label: 'dbi_top_rank_wechat_bestseller', value: 'wechat_bestseller', icon: WeixinIcon },
          { label: 'dbi_top_rank_wechat_most_played', value: 'wechat_most_played', icon: WeixinIcon },
          { label: 'dbi_top_rank_douyin_popularity', value: 'douyin_popularity', icon: DouyinIcon },
          { label: 'dbi_top_rank_douyin_bestseller', value: 'douyin_bestseller', icon: DouyinIcon },
          { label: 'dbi_top_rank_douyin_fresh_game', value: 'douyin_fresh_game', icon: DouyinIcon },
        ],
      },
      {
        label: 'dbi_download_language',
        type: 'radio',
        field: 'download_language',
        defaultValue: LANGUAGE_CN,
        options: [
          { label: 'dbi_download_language_option_cn', value: LANGUAGE_CN },
          { label: 'dbi_download_language_option_en', value: LANGUAGE_EN },
        ],
      },
      {
        label: 'dbi_label_basic_info',
        type: 'checkbox',
        field: 'data_sources',
        defaultValue: {
          company_show: false,
          genre_show: false,
        },
        options: [
          { label: 'dbi_label_company_info', value: 'company_show' },
          { label: 'dbi_label_genre', value: 'genre_show' },
        ],
      },
      {
        label: 'dbi_label_time_settings',
        type: 'dateRangeDay',
        defaultValue: [defaultDate, defaultDate],
        field: 'dateRange',
        options: [],
      },
      {
        label: 'dbi_label_data_calculation_change',
        type: 'switch',
        defaultValue: true,
        field: 'ratio_show',
        options: [],
      },
    ],
  },
};

export default mobileConfig;
